// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const BadgeContract = contract({
  name: "Badge",
  description: "Compact status chips, counts, tags, pills. For higher-signal inline status → use Callout. For solid CTAs → Button. Soft/outline variants are quieter; solid variants are loud.",
  import: "@gradeui/ui",
  aliases: ["chip","tag","pill","label chip","badge","tag view","status pill","token","count badge"],
  element: "div",
  composesWith: ["Card","Table (inside a cell)","Avatar (next to it)","anywhere inline"],
  styleDefaults: {"Badge":"inline-flex items-center gap-1 border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 [&_svg]:size-3 [&_svg]:shrink-0 border-transparent bg-primary text-primary-foreground hover:bg-primary/80 rounded-md"},
  variantDefaults: {"variant":"default","rounded":"default"},
  props: {
  "variant": {
      schema: z.enum(["default", "secondary", "destructive", "outline", "highlight", "success", "warning", "info", "success-soft", "warning-soft", "destructive-soft", "info-soft", "highlight-soft", "success-outline", "warning-outline", "destructive-outline", "info-outline"]).optional(),
      design: "knob",
  },
  "rounded": {
      schema: z.enum(["default", "full"]).optional(),
      design: "knob",
      description: "\"full\" gives a pill shape",
  },
  },
});
